import request from '@/axios'


export function createActivitiesMeeting (postData) {
  return request({
    url: '/activities/create_activities_meetings',
    method: 'POST',
    data: postData
  })
}


//need to change
export function activitiesMeetingList (limit, query, type, leadId, customerId) {
  return request({
    url:`/activities/list_activities_meetings/${limit}/${type}/${leadId}/${customerId}?page=${query.current_page + 1}`,
    method:'GET'
  })
}


export function fetchActivitiesMeetingDetails (id) {
  return request({
    url:`/activities/fetch_activites_meetings/${id}`,
    method:'GET'
  })
}


export function deleteActivitesMeeting (id) {
  return request({
    url:`activities/delete_activities_meetings/${id}`,
    method:'GET'
  })
}


export function editActivitesMeeting (putData) {
  return request({
    url: '/activities/edit_activities_meetings',
    method: 'PUT',
    data: putData
  })
}

